import React from 'react';
import { WifiOff } from 'lucide-react';
import { useOnline } from '../../hooks/useOnline';

export const OfflineStrip: React.FC = () => {
  const online = useOnline();
  if (online) return null;

  return (
    <div
      className='flex items-center gap-2.5 px-4 py-2.5 text-[12.5px] font-medium'
      style={{
        background: 'rgba(251,191,36,0.08)',
        borderBottom: '1px solid rgba(251,191,36,0.2)',
        color: 'var(--color-text)',
      }}
    >
      <WifiOff className='w-3.5 h-3.5 text-amber-400 shrink-0' />
      <span className='flex-1' style={{ color: 'rgba(255,255,255,0.85)' }}>
        You're offline — showing cached data
      </span>
    </div>
  );
};
